var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 56,
    viewBox: "0 0 67 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0297 55.9051C28.2679 55.9051 23.4825 56.0928 18.7207 55.8582C10.6044 55.4829 5.34987 50.2753 5.16221 42.1356C4.92764 32.6353 4.95109 23.135 5.20913 13.6581C5.39679 5.75296 10.7216 0.404642 18.6268 0.193524C28.1975 -0.0645082 37.7916 -0.0645082 47.3623 0.193524C55.244 0.381185 60.5923 5.7295 60.8034 13.6112C61.0615 23.1819 61.0615 32.776 60.8269 42.3232C60.6392 50.2753 55.2909 55.4829 47.3154 55.8582C42.5535 56.0693 37.7916 55.9051 33.0297 55.9051ZM35.9619 23.2757C35.4224 23.0411 35.0705 22.9004 34.7187 22.7597C32.889 21.9386 30.9655 21.6806 28.995 21.9152C23.1541 22.6658 18.9318 27.9203 19.4009 33.8316C19.8701 39.6725 25.0073 44.0356 31.1062 43.7776C36.7595 43.543 41.3102 38.6873 41.3102 32.8229C41.3102 28.4129 41.3102 24.0029 41.2868 19.5694C41.2868 19.1472 41.2868 18.7484 41.2868 18.0681C42.1313 18.5373 42.7177 18.8892 43.3276 19.2176C45.0869 20.1793 46.7055 19.8744 47.503 18.4435C48.3006 16.9891 47.7376 15.394 46.0487 14.4322C44.1251 13.3063 42.1782 12.2272 40.2781 11.0778C39.2929 10.4914 38.2842 10.3506 37.2756 10.9136C36.22 11.5 35.8212 12.4618 35.8446 13.6581C35.8916 16.4027 35.915 19.1237 35.9385 21.8683C35.9619 22.267 35.9619 22.6893 35.9619 23.2757Z",
    fill: "url(#paint0_linear_793_7921)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_793_7921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9619 23.2757C35.9619 22.6893 35.9619 22.2905 35.9619 21.8683C35.9385 19.1238 35.9385 16.4027 35.8681 13.6582C35.8446 12.4618 36.2434 11.5001 37.299 10.9136C38.3077 10.3507 39.3163 10.4914 40.3016 11.0778C42.2251 12.2038 44.1486 13.3063 46.0721 14.4323C47.7611 15.4175 48.324 16.9891 47.5265 18.4435C46.7289 19.8979 45.1104 20.2028 43.351 19.2176C42.7411 18.8892 42.1547 18.5373 41.3102 18.0682C41.3102 18.7484 41.3102 19.1472 41.3102 19.5695C41.3102 23.9795 41.3337 28.3895 41.3337 32.8229C41.3102 38.6873 36.7829 43.5196 31.1297 43.7776C25.0307 44.0356 19.8935 39.6725 19.4244 33.8316C18.9552 27.9203 23.1776 22.6658 29.0185 21.9152C30.9889 21.6572 32.9124 21.9387 34.7421 22.7597C35.0471 22.9004 35.3989 23.0412 35.9619 23.2757Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_793_7921",
    x: 0.622784,
    y: 10.5572,
    width: 66.0265,
    height: 75.4548,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.64913
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.259652
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_793_7921"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.55995
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.623979
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_793_7921",
    result: "effect2_dropShadow_793_7921"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.93724
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1749
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_793_7921",
    result: "effect3_dropShadow_793_7921"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.23954
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.09582
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_793_7921",
    result: "effect4_dropShadow_793_7921"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.79999
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.92
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_793_7921",
    result: "effect5_dropShadow_793_7921"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23.4575
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.38301
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_793_7921",
    result: "effect6_dropShadow_793_7921"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_793_7921",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_793_7921",
    x1: 33,
    y1: 0,
    x2: 33,
    y2: 55.9762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2C71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1954"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.08660d585386004021dd0d30bd30eb19.svg";
export { ForwardRef as ReactComponent };